<template>
  <div
    :class="[
      `w-100 d-flex justify-content-${justify} mc-readonly`,
      { 'flex-column': orientation === 'vertical' },
    ]"
  >
    <div class="mc-readonly__item" v-for="(item, idx) in items" :key="idx">
      <div class="__label">{{ item.label }}</div>
      <div :class="`__value${item.bold ? '-bold' : ''}`">{{ item.value }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
    orientation: {
      type: String,
      default: 'horizontal',
    },
    justify: {
      type: String,
      default: 'between',
    },
  },
}
</script>

<style lang="scss">
// Techdebt: refactor the hex color as new SCSS variables
.mc-readonly {
  gap: 16px;

  &__item {
    .__label {
      // Secondary/Navy/Navy 40
      color: $mep-color-text-200;
    }

    // color: $secondary;
    .__value {
      // Secondary/Navy/Navy 60
      color: $mep-color-text-300;
    }
    .__value-bold {
      // Secondary/Navy/Navy 80
      color: $mep-color-text-400;
      font-weight: 600;
    }
  }
}
</style>
